<template>
  <div
    ref="trigger"
    class="inline-flex"
    @mouseenter="onMouseEnter"
    @mouseleave="visible = false"
  >
    <slot />
    <div
      v-if="visible && sections.length"
      class="fixed z-50 pointer-events-none flex flex-col items-center"
      :style="tooltipStyle"
    >
      <div
        class="bg-gray-800 rounded-lg px-3 py-2 whitespace-nowrap"
        style="box-shadow: 0px 1px 2px rgba(17, 24, 39, 0.06), 0px 1px 3px rgba(17, 24, 39, 0.1);"
      >
        <div class="flex flex-col gap-4">
          <div
            v-for="(section, i) in sections"
            :key="i"
            class="flex flex-col gap-1"
          >
            <div class="text-xs text-gray-300 leading-[18px]">
              {{ section.label }}:
            </div>
            <div
              v-for="email in section.emails"
              :key="email"
              class="text-sm text-white leading-5"
            >
              {{ email }}
            </div>
          </div>
        </div>
      </div>
      <svg
        width="16"
        height="8"
        viewBox="0 0 16 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 0H0L6.58579 6.58579C7.36684 7.36684 8.63317 7.36684 9.41421 6.58579L16 0Z"
          fill="#1F2937"
          style="
            fill: #1f2937;
            fill: color(display-p3 0.1216 0.1608 0.2157);
            fill-opacity: 1;
          "
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      triggerRect: null,
    };
  },
  computed: {
    tooltipStyle() {
      if (!this.triggerRect) return {};
      return {
        top: `${this.triggerRect.top}px`,
        left: `${this.triggerRect.left + this.triggerRect.width / 2}px`,
        transform: 'translate(-50%, calc(-100% - 4px))',
      };
    },
  },
  methods: {
    onMouseEnter() {
      this.triggerRect = this.$refs.trigger.getBoundingClientRect();
      this.visible = true;
    },
  },
};
</script>
